module.exports = __webpack_public_path__ + "static/media/order.af82e17e.svg";